import { Button, message, Modal } from 'antd'
import { ReactComponent as Copy } from '@/assets/icons/copy.svg'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'
import { copyTextToClipboard } from '@/utils/clipboard'

const SafeheronIP = memo(() => {
  const { t } = useTranslation()
  const handleCopy = () => {
    const success = copyTextToClipboard('18.162.105.64 18.167.22.59 18.167.21.182')
    if (success) {
      message.success(`${t('clipboard.copySuccess')}`)
    }
  }
  return (
    <div className={styles.container}>
      <div className={styles.title}> {t('api.SafeheronIp')}</div>
      <div className={styles.content}>
        <div className={styles.desc}>
          {t('api.SafeheronIpDesc')}
          <div className={styles.card}>
            <div>18.162.105.64</div>
            <div>18.167.22.59</div>
            <div>18.167.21.182</div>
            <div
              style={{
                height: '1px',
                backgroundColor: '#D8D8D8',
                marginTop: '15px',
                marginBottom: '5px',
              }}
            ></div>
            <div className={styles.copy}>
              <Copy style={{ width: '16px', height: '16px', marginRight: '10px' }} />
              <Button type="link" onClick={handleCopy}>
                {t('common.copy')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          type="primary"
          style={{ width: '140px', height: '40px' }}
          onClick={() => Modal.destroyAll()}
        >
          {t('api.ok')}
        </Button>
      </div>
    </div>
  )
})

export default SafeheronIP
